<script setup lang="ts">
import { type Component, computed, ref } from 'vue'
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger
} from 'radix-vue'
import CloseSvg from '@/assets/X.svg'
import KebabSvg from '@/assets/icons/kebab.svg'
import { DrillManageActionType } from '@/types'

import EditSvg from '@/assets/icons/linear/edit.svg'
import ResetSvg from '@/assets/icons/linear/reload.svg'
import DeleteSvg from '@/assets/icons/linear/bin.svg'
import ShareSvg from '@/assets/icons/share2.svg'
import CopySvg from '@/assets/icons/copy.svg'

const manageMenuItems = [
  {
    type: DrillManageActionType.edit,
    labelKey: 'EditDrill',
    icon: EditSvg
  },
  {
    type: DrillManageActionType.share,
    labelKey: 'ShareDrill',
    icon: ShareSvg
  },
  {
    type: DrillManageActionType.resetStats,
    labelKey: 'ResetStats',
    icon: ResetSvg
  },
  {
    type: DrillManageActionType.duplicate,
    labelKey: 'Duplicate',
    icon: CopySvg
  },
  {
    type: DrillManageActionType.delete,
    labelKey: 'DeleteDrill',
    icon: DeleteSvg
  }
]

defineEmits<{
  onActionSelect: [string]
}>()

const { visibleActions = [] } = defineProps<{
  visibleActions?: string[]
}>()

const isMenuVisible = ref(false)

const visibleMenuItems = computed(() =>
  manageMenuItems.filter((el) => visibleActions.includes(el.type))
)
</script>

<template>
  <div class="flex gap-2" :class="{ 'menu-expanded': isMenuVisible }">
    <!-- icons -->
    <button
      v-for="action in visibleMenuItems"
      :key="action.type"
      class="text-text-soft cursor-pointer rounded-[8px] hover:text-white"
      @click.stop="$emit('onActionSelect', action.type)"
      v-tooltip.bottom="$t(`CustomDrills.button.${action.labelKey}`)"
    >
      <component :is="action.icon" class="h-6 w-6" />
    </button>

    <!-- menu -->
    <!-- <dropdown-menu-root v-model:open="isMenuVisible">
      <dropdown-menu-trigger aria-label="Manage drill" @click.stop>
        <close-svg v-if="isMenuVisible" class="w-6 h-6 text-white" />
        <kebab-svg v-else class="w-6 h-6 text-3 hover:text-white" />
      </dropdown-menu-trigger>
      <dropdown-menu-portal>
        <dropdown-menu-content
          class="z-999 outline-hidden bg-light-grey rounded-xl p-1 mr-4 transition-all will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade"
        >
          <div class="flex flex-col gap-0.5">
            <dropdown-menu-item
              v-for="action in manageMenuItems"
              :value="action.type"
              class="cursor-pointer h-[30px] min-w-[168px] px-2 rounded-[8px] bg-menu-item-bg text-white flex items-center gap-2 text-base hover:opacity-80"
              @click.stop="$emit('onActionSelect', action.type)"
            >
              <component :is="action.icon" />
              <div>{{ $t(`CustomDrills.button.${action.labelKey}`) }}</div>
            </dropdown-menu-item>
          </div>
        </dropdown-menu-content>
      </dropdown-menu-portal>
    </dropdown-menu-root> -->
  </div>
</template>
